import { createSlice } from "@reduxjs/toolkit";
export const WBRAnalysis = createSlice({
  name: "WBRAnalysis",

  initialState: {
    wbrData: null,
    startDate: null,
    endDate: null,
    filters: null,
    weeklyData: null,
    monthlyData: null,
    rawMonthlyData: null,
    rawWeeklyData: null,
    selectedSalesChanel: null,
    selectedWarehousestate: null,
    selectedPartNumber: null,
    selectedItemTitle: null,
    salesChannelData: null,
    inventoryData: null,
    inventoryFilters: null,
    inventorySelectedPartNumber: null,
    trafficData: null,
    trafficFilters: null,
    trafficSelectedPartNumber: null,
    trafficWeeklyData: null,
    trafficFilter: null,
    partNumberShippedData: null,
    currentWeek: null,
    partnumberTotal: null,
    qohData: null,
    partnumberData: null,
    asinObject: null,
    partNumberObject: null,
    universalLoading: null,
    advertisementData: null,
    advertisementDailyData: null,
    advertisementMonthlyData: null,
    advertisementLoading: false,
    advertisementFilters: false,
    advertisementSelectedPartnumbers: [],
    advertisementTableChannelData: null,
    advertisementTablePartnumberData: null,
    executiveChartData: null,
    monthlyChartData: null,
    dailyChartData: null,
    executiveChartDateRange: null,
    monthlyChartDateRange: null,
    dailyChartDateRange: null,
  },

  reducers: {
    addWBRData: (state, action) => {
      state.wbrData = action.payload;
    },
    addStartDate: (state, action) => {
      state.startDate = action.payload;
    },
    addEndDate: (state, action) => {
      state.endDate = action.payload;
    },
    addFilters: (state, action) => {
      state.filters = action.payload;
    },
    addWeeklyData: (state, action) => {
      state.weeklyData = action.payload;
    },
    addSelectedItemTitle: (state, action) => {
      state.selectedItemTitle = action.payload;
    },
    addSelectedPartNumber: (state, action) => {
      state.selectedPartNumber = action.payload;
    },
    addSelectedWarehousestate: (state, action) => {
      state.selectedWarehousestate = action.payload;
    },
    addSelectedSalesChanel: (state, action) => {
      state.selectedSalesChanel = action.payload;
    },
    addSalesChannelData: (state, action) => {
      state.salesChannelData = action.payload;
    },
    addMonthlyData: (state, action) => {
      state.monthlyData = action.payload;
    },
    addRawMonthlyData: (state, action) => {
      state.rawMonthlyData = action.payload;
    },
    addRawWeeklyData: (state, action) => {
      state.rawWeeklyData = action.payload;
    },
    addInventoryData: (state, action) => {
      state.inventoryData = action.payload;
    },
    addInventoryFilters: (state, action) => {
      state.inventoryFilters = action.payload;
    },
    addInventorySelectedPartNumber: (state, action) => {
      state.inventorySelectedPartNumber = action.payload;
    },
    addTrafficData: (state, action) => {
      state.trafficData = action.payload;
    },
    addTrafficFilters: (state, action) => {
      state.trafficFilters = action.payload;
    },
    addTrafficSelectedPartNumber: (state, action) => {
      state.trafficSelectedPartNumber = action.payload;
    },
    addTrafficWeeklyData: (state, action) => {
      state.trafficWeeklyData = action.payload;
    },
    addTrafficFilter: (state, action) => {
      state.trafficFilter = action.payload;
    },
    addPartNumberShippedData: (state, action) => {
      state.partNumberShippedData = action.payload;
    },
    addCurrentWeek: (state, action) => {
      state.currentWeek = action.payload;
    },
    addPartnummberTotal: (state, action) => {
      state.partnumberTotal = action.payload;
    },
    addQohData: (state, action) => {
      state.qohData = action.payload;
    },
    addPartnumberData: (state, action) => {
      state.partnumberData = action.payload;
    },
    addAsinObject: (state, action) => {
      state.asinObject = action.payload;
    },
    addPartNumberObject: (state, action) => {
      state.partNumberObject = action.payload;
    },
    addUniversalLoading: (state, action) => {
      state.universalLoading = action.payload;
    },
    addAdvertisementData: (state, action) => {
      state.advertisementData = action.payload;
    },
    addAdvertisementLoading: (state, action) => {
      state.advertisementLoading = action.payload;
    },
    addAdvertisementMonthlyData: (state, action) => {
      state.advertisementMonthlyData = action.payload;
    },
    addAdvertisementDailyData: (state, action) => {
      state.advertisementDailyData = action.payload;
    },
    addAdvertisementFilters: (state, action) => {
      state.advertisementFilters = action.payload;
    },
    addAdvertisementSelectedPartnumbers: (state, action) => {
      state.advertisementSelectedPartnumbers = action.payload;
    },
    addAdvertisementTablePartnumberData: (state, action) => {
      state.advertisementTablePartnumberData = {
        ...state.advertisementTablePartnumberData,
        ...action.payload,
      };
    },
    addAdvertisementTableChannelData: (state, action) => {
      state.advertisementTableChannelData = {
        ...state.advertisementTableChannelData,
        ...action.payload,
      };
    },
    addExecutiveChartData: (state, action) => {
      state.executiveChartData = action.payload;
    },
    addMonthlyChartData: (state, action) => {
      state.monthlyChartData = action.payload;
    },
    addDailyChartData: (state, action) => {
      state.dailyChartData = action.payload;
    },
    setExecutiveChartDateRange: (state, action) => {
      state.executiveChartDateRange = action.payload;
    },
    setMonthlyChartDateRange: (state, action) => {
      state.monthlyChartDateRange = action.payload;
    },
    setDailyChartDateRange: (state, action) => {
      state.dailyChartDateRange = action.payload;
    },

    storeCleanupWBR: (state, action) => {
      state.wbrData = null;
      state.startDate = null;
      state.endDate = null;
      state.filters = null;
      state.weeklyData = null;
      state.selectedItemTitle = null;
      state.selectedWarehousestate = null;
      state.selectedSalesChanel = null;
      state.selectedPartNumber = null;
      state.salesChannelData = null;
      state.monthlyData = null;
      state.rawMonthlyData = null;
      state.rawWeeklyData = null;
      state.inventoryData = null;
      state.inventoryFilters = null;
      state.inventorySelectedPartNumber = null;
      state.trafficData = null;
      state.trafficFilters = null;
      state.trafficSelectedPartNumber = null;
      state.trafficWeeklyData = null;
      state.trafficFilter = null;
      state.partNumberShippedData = null;
      state.currentWeek = null;
      state.partnumberTotal = null;
      state.qohData = null;
      state.partnumberData = null;
      state.asinObject = null;
      state.partNumberObject = null;
      state.universalLoading = null;
      state.advertisementData = null;
      state.advertisementLoading = null;
      state.advertisementDailyData = null;
      state.advertisementMonthlyData = null;
      state.advertisementFilters = null;
      state.advertisementSelectedPartnumbers = [];
      state.advertisementTableChannelData = null;
      state.advertisementTablePartnumberData = null;
      state.executiveChartData = null;
      state.monthlyChartData = null;
      state.dailyChartData = null;
      state.executiveChartDateRange = null;
      state.monthlyChartDateRange = null;
      state.dailyChartDateRange = null;
    }
  }
});

export const {
  addWBRData,
  addEndDate,
  addStartDate,
  addFilters,
  addWeeklyData,
  storeCleanupWBR,
  addSelectedSalesChanel,
  addSelectedWarehousestate,
  addSelectedPartNumber,
  addSelectedItemTitle,
  addSalesChannelData,
  addMonthlyData,
  addRawMonthlyData,
  addRawWeeklyData,
  addInventoryData,
  addInventoryFilters,
  addInventorySelectedPartNumber,
  addTrafficSelectedPartNumber,
  addTrafficFilters,
  addTrafficData,
  addTrafficWeeklyData,
  addTrafficFilter,
  addPartNumberShippedData,
  addCurrentWeek,
  addPartnummberTotal,
  addQohData,
  addPartnumberData,
  addAsinObject,
  addPartNumberObject,
  addUniversalLoading,
  addAdvertisementData,
  addAdvertisementLoading,
  addAdvertisementMonthlyData,
  addAdvertisementDailyData,
  addAdvertisementFilters,
  addAdvertisementSelectedPartnumbers,
  addAdvertisementTableChannelData,
  addAdvertisementTablePartnumberData,
  addExecutiveChartData,
  addMonthlyChartData,
  addDailyChartData,
  setExecutiveChartDateRange,
  setMonthlyChartDateRange,
  setDailyChartDateRange
} = WBRAnalysis.actions;
export default WBRAnalysis.reducer;
